import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BackdropModule } from '../../@fury/shared/backdrop/backdrop.module';
import { MaterialModule } from '../../@fury/shared/material-components.module';
import { LayoutComponent } from './layout.component';
import { FurySharedModule } from '../../@fury/fury-shared.module';
import { SurveyModule } from '../pages/survey/survey.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FurySharedModule,

    // Core
    BackdropModule,
    SurveyModule,
  ],
  declarations: [LayoutComponent]
})
export class LayoutModule {
}
